import { useEffect, useState } from "react";
import { ACTIVE_URL } from "@/constants";

interface LegalProps {
  slug: string;
  fallbackTitle: string;
}

export function Legal({ slug, fallbackTitle }: LegalProps) {
  const [title, setTitle] = useState(fallbackTitle);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${ACTIVE_URL}/api/content/${slug}/`)
      .then((r) => r.json())
      .then((data) => {
        if (data.title) setTitle(data.title);
        setContent(data.content || "");
      })
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-white mb-8">{title}</h1>
        {loading ? (
          <div className="text-white/40">Loading…</div>
        ) : content ? (
          <div
            className="prose prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <p className="text-white/60">Το περιεχόμενο θα είναι διαθέσιμο σύντομα.</p>
        )}
      </div>
    </div>
  );
}
